import api from "./api";

export default class ExtratoApi {
  static getExtractPerClient = async (
    page: Number,
    RecordsPerPage: Number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  // Rota nova do extrato: uma consulta so, ja com a ponte do split resolvida
  // no servidor. Ao contrario da v1, respeita Page/RecordsPerPage.
  static getExtractPerClientV2 = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    page?: number,
    recordsPerPage?: number
  ) => {
    const paginacao =
      page && recordsPerPage
        ? `&Page=${page}&RecordsPerPage=${recordsPerPage}`
        : "";
    const response = await api.get(
      `/Extrato/v2?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}${paginacao}`
    );
    return response;
  };

  // Linhas do EXTRATO SPLIT (tabela ExtratoSplit) — mesma forma do
  // getExtractPerClientV2, apontando para /ExtratoSplit. E de onde saem as
  // SAIDAS do split (repasse automatico entra como tipoLancamento 15), que nao
  // aparecem no extrato principal.
  static getSplitPerClientV2 = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    page?: number,
    recordsPerPage?: number
  ) => {
    const paginacao =
      page && recordsPerPage
        ? `&Page=${page}&RecordsPerPage=${recordsPerPage}`
        : "";
    const response = await api.get(
      `/ExtratoSplit/v2?dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}${paginacao}`
    );
    return response;
  };

  // Saldo do razao SPLIT (anterior + periodo). Devolve linha apenas para cliente
  // que tem alguma movimentacao na ExtratoSplit — e o que diz se ele opera com
  // split, independente de ter tido lancamento no periodo consultado.
  static getSplitSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/ExtratoSplit/saldo?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  // `signal` (AbortController) e opcional: quem passa consegue cancelar a
  // consulta ao sair da tela. Esta rota agrega o periodo inteiro por cliente e
  // e a mais lenta da listagem — deixar ela correndo depois que o usuario ja
  // navegou so ocupa banco e conexao a toa.
  static getExtractList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    filtroSaldo: string,
    signal?: AbortSignal
  ) => {
    const response = await api.get(
      `/Extrato/listagem?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}&filtroSaldo=${filtroSaldo}`,
      { signal }
    );
    return response.data;
  };

  static getExtractFutureReleasesList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&lancamentosFuturos=${true}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldoVendas = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas/${idCliente}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response;
  };

  static postLancamento = async (obj: any) => {
    const response = await api.post(`/Extrato`, obj);
    return response.data;
  };

  static getFutureSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas-futuras?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static exportFile = async (
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string,
    ModoPgto: any,
    idStatus: any
  ) => {
    const response = await api.get(
      `/Transacao/download?dataInicio=${dataInicio}&dataFim=${dataFim}&Search=${search}&idCliente=${id}&ModoPgto=${ModoPgto}&idStatus=${idStatus}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static getSaldoBandeira = async (dataInicio: any, dataFim: any, id: any) => {
    const response = await api.get(
      `/Saldo/bandeira/${id}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response.data;
  };
}
